/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteCardLinkWithThreeDSRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CompleteCardLinkWithThreeDS.pb'
import {CompleteCardLinkWithThreeDSResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CompleteCardLinkWithThreeDS.pb'


export const completeCardLinkWithThreeDS = (request:CompleteCardLinkWithThreeDSRequest, options?: CashRequestOptions) => post<CompleteCardLinkWithThreeDSRequest, CompleteCardLinkWithThreeDSResponse>("/2.0/cash/complete-card-link-with-three-d-s", request, {...options, rejectOnError: true })